import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { getDescription } from "pages/employer-of-record/utils";
import * as GERMANY from "pages/employer-of-record/onboarding/profile-info/form/de/constants.de";
import { countryIs, field, OPTIONAL, REQUIRED } from "./utils";
import { NATIONALITIES } from "pages/employer-of-record/onboarding/profile-info/constants";
import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const germanyFields = {
  deCountryOfBirth: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "deCountryOfBirth",
    label: "Geburtsland (Country of Birth)",
    placeholder: "Select Country of Birth",
    validations: REQUIRED,
    options: NATIONALITIES,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deCountryOfBirth in ProfileInfo query
  }),

  deMainEmployer: field({
    type: FieldTypes.boolean,
    informationType: "job",
    name: "deMainEmployer",
    label:
      "Ist dieses Unternehmen Ihr Hauptarbeitgeber? (Is this company your main employer?)",
    placeholder: "Select Main Employer Status",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => true, // TODO: expose deMainEmployer in ProfileInfo query
  }),

  dePensionInsuranceNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "dePensionInsuranceNumber",
    label: "Rentenversicherungsnummer (Pension Insurance Number)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose dePensionInsuranceNumber in ProfileInfo query
  }),

  deHealthInsuranceStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "deHealthInsuranceStatus",
    label: "Krankenversicherungsstatus (Health Insurance Status)",
    placeholder: "Select Health Insurance Status",
    validations: REQUIRED,
    options: GERMANY.deHealthInsuranceStatusOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deHealthInsuranceStatus in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deHealthInsuranceStatusOptions, value) ?? value,
  }),

  deHealthInsuranceProvider: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "deHealthInsuranceProvider",
    label: "Krankenkasse (Health Insurance Provider)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deHealthInsuranceProvider in ProfileInfo query
  }),

  deSchoolDegree: field({
    type: FieldTypes.select,
    informationType: "education",
    name: "deSchoolDegree",
    label: "Schulabschluss (School Degree)",
    placeholder: "Select School Degree",
    options: GERMANY.deSchoolDegreeOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deSchoolDegree in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deSchoolDegreeOptions, value) ?? value,
  }),

  deProfessionalQualification: field({
    type: FieldTypes.select,
    informationType: "education",
    name: "deProfessionalQualification",
    label: "Berufsabschluss (Professional Qualification)",
    placeholder: "Select Professional Qualification",
    options: GERMANY.deProfessionalQualificationOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deProfessionalQualification in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deProfessionalQualificationOptions, value) ??
      value,
  }),

  deMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "deMaritalStatus",
    label: "Familienstand (Marital Status)",
    placeholder: "Select Marital Status",
    validations: REQUIRED,
    options: GERMANY.deMaritalStatusOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deMaritalStatus in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deMaritalStatusOptions, value) ?? value,
  }),

  deReligion: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "deReligion",
    label: "Religion",
    placeholder: "Select Religion",
    validations: REQUIRED,
    options: GERMANY.deReligionOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deReligion in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deReligionOptions, value) ?? value,
  }),

  deEligibleChildren: field({
    type: FieldTypes.number,
    informationType: "family",
    name: "deEligibleChildren",
    label:
      "Berücksichtigfähige Kinder für PV-Abschlag (Eligible Children for Long-Term Care Deduction)",
    validations: {
      ...OPTIONAL,
      number: {
        min: {
          value: 0,
          message: "Must be a positive number",
        },
        max: {
          value: 4,
          message: "Cannot be greater than 4",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "0", // TODO: expose deEligibleChildren in ProfileInfo query
    serialize: (value) => parseInt(value, 10),
  }),

  deTaxClass: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "deTaxClass",
    label: "Tax Class",
    placeholder: "Select Tax Class",
    validations: REQUIRED,
    options: GERMANY.deTaxClassOptions,
    scenarios: {
      onboarding: countryIs("DE"),
    },
    value: () => "", // TODO: expose deTaxClass in ProfileInfo query
    format: (value) =>
      getDescription(GERMANY.deTaxClassOptions, value) ?? value,
  }),

  deIdnr: taxIdFieldConfig("DE", "deIdnr"),
  deConfirmIdnr: confirmTaxIdFieldConfig("DE", "deIdnr"),
};
